import { render, staticRenderFns } from "./AddTemplate.template.vue?vue&type=template&id=18e53108&scoped=true&"
var script = {}
import style0 from "./AddTemplate.template.vue?vue&type=style&index=0&id=18e53108&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e53108",
  null
  
)

export default component.exports